import { z } from 'zod';
import { PlayerEventSchema, SessionEventSchema } from './events';
import { GameDefinitionSchema } from './game-definition';
import { PlayerSchema } from './player';
import { SessionMetadataSchema } from './session';
import { SessionTemplateSchema } from './session-template';
import { TeamPresetSchema } from './team';
import { SCHEMA_VERSIONS } from './versions';

const tableCountSchema = z.number().int().nonnegative();

export const BackupMetadataSchema = z.object({
  exportedAt: z.string().refine((value) => !Number.isNaN(Date.parse(value)), {
    message: 'exportedAt must be a valid ISO timestamp',
  }),
  appVersion: z.string(),
  databaseVersion: z.number().int().positive(),
  schemaVersions: z.object({
    sessionEvent: z.number().int().positive().default(SCHEMA_VERSIONS.SESSION_EVENT),
    playerEvent: z.number().int().positive().default(SCHEMA_VERSIONS.PLAYER_EVENT),
  }),
  tableCounts: z.object({
    sessionEvents: tableCountSchema,
    playerEvents: tableCountSchema,
    players: tableCountSchema,
    gameDefinitions: tableCountSchema,
    teamPresets: tableCountSchema,
    sessionMetadata: tableCountSchema,
    sessionTemplates: tableCountSchema,
  }),
});

export const BackupDataSchema = z.object({
  sessionEvents: z.array(SessionEventSchema),
  playerEvents: z.array(PlayerEventSchema),
  players: z.array(PlayerSchema),
  gameDefinitions: z.array(GameDefinitionSchema),
  teamPresets: z.array(TeamPresetSchema),
  sessionMetadata: z.array(SessionMetadataSchema),
  sessionTemplates: z.array(SessionTemplateSchema),
});

export const BackupPayloadSchema = z.object({
  metadata: BackupMetadataSchema,
  data: BackupDataSchema,
});

export type BackupMetadata = z.infer<typeof BackupMetadataSchema>;
export type BackupData = z.infer<typeof BackupDataSchema>;
export type BackupPayload = z.infer<typeof BackupPayloadSchema>;
